module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG550c781bed908837d190f0172606bf4b.550c781b.png";